export const APP_ROUTE_PATHS = {
  signIn: 'signin',
  operator: 'operator',
  shuttle: 'shuttle',
  notFound: '404'
} as const;

export const LEGACY_ROUTE_PREFIXES = {
  access: 'access',
  app: 'app'
} as const;
